import React from 'react';
import TrialImg from './trialSurvey.jpg';
import List from "../list";

function TrialSurvey() {
  return (
    <div>
      <div className="hero">
        <img
          className="h-96 w-full object-cover object-center"
          src={TrialImg}
          alt="trial survey"
        />
      </div>

      <div className="container mt-4 mb-4">
        <div>
          <h3 className="font-black leading-none text-gray-800 uppercase dark:text-white">Trial Survey Guidelines</h3>

          <div className="flex flex-col gap-2 justify-start items-start">
            <List description="Duly completed declaration forms, A & B of the third schedule of the Survey Act." />

            <List description="Attach Certified Academic Certificates" />

            <List description="A duly completed application form of the Land Surveyors Board" />

            <List description="Application letter to the Board" />

            <List description="Pay applicable fees." />
          </div>
        </div>

        <div className="mt-5">
          <h3 className='font-black leading-none text-gray-800 uppercase dark:text-white'>Examination Requirements</h3>

          <p className='font-medium'>The candidate shall qualify for a Ten (10) weeks Trial Survey if he/she has at least two (2) Years of approved experience. <br /> The candidate shall sit the following examinations:</p>

          <div className="flex flex-col gap-2 justify-start items-start">
            <List description="Viva Voce (Oral Examinations in Surveying)" />

            <List description="Trial Survey:" />

            <ul className="mx-12" style={{ listStyleType: 'square' }}>
              <li className="text-gray-700 font-medium">Field determination of local time, latitude, longitude and azimuth.</li>
              <li className="text-gray-700 font-medium">Provisions of adequate control to cover a rural area, the subject of further survey.</li>
              <li className="text-gray-700 font-medium">Survey of rural area referred to, including the traverse of a curvilinear boundary, and the re-establishment of a lost beacon. The curvilinear boundary may be required to be determined from air photographs supplied</li>
              <li className="text-gray-700 font-medium">Survey of a small township area with buildings thereon, which include restoration of an old survey.</li>
            </ul>

            <List description="Topographical and Contour Survey:" />

            <ul className='mx-12' style={{ listStyleType: 'square' }}>
              <li className='text-gray-700 font-medium'>Setting out Engineering structures.</li>
              <li className='text-gray-700 font-medium'>The original field notes, computations and plans must be submitted to the Board, together with a certificate in the form prescribed in regulation 21 of these Regulations.</li>
            </ul>

            <List description="Law Examination:" />

            <ul className='mx-12'>
              <li className='text-gray-700 font-medium'>A written examination on the text and application of such Acts as the Board may from time to time prescribe, and the rules, regulations and by-laws made thereunder, so far as they affect survey and the law relating to land control, land registration and title to land.</li>
            </ul>
          </div>
        </div>

        <div className="mt-5">
          <p className='font-medium'>The candidate is notified of the following:</p>

          <div className="flex flex-col gap-2 justify-start items-start">
            <List description="That he/she should carry out the actual observations." />

            <List description="He keeps a diary of events for the assignments." />

            <List description="He develops a timetable of events which he shares with the Board and in addition notifies the Board of observation days and times at least two weeks in advance for supervision purposes." />

            <List description="That the whole assignment will last takes 10 weeks." />

            <List description="The candidate meets his/ her own costs including equipment." />
          </div>

          <p className="mt-4 font-medium">The assignments can follow any order but the oral examinations shall be done after all the assignments have been submitted.</p>
        </div>
      </div>
    </div>
  )
}

export default TrialSurvey;